import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { RiCloseLine, RiPencilLine } from "@remixicon/react";

const sharedProps = {
  ml: 1,
  mr: -2,
  variant: "ghostDimmed",
} as const;

export type TagEditProps = Omit<IconButtonProps, "icon" | "aria-label"> & {
  onEdit: () => void;
};

export function TagEdit({ onEdit, size = "2xs", ...props }: TagEditProps) {
  return (
    <IconButton
      {...sharedProps}
      aria-label="Edit"
      icon={<RiPencilLine size={16} />}
      size={size}
      onClick={(e) => {
        e.stopPropagation();
        onEdit();
      }}
      {...props}
    />
  );
}

export type TagRemoveProps = Omit<IconButtonProps, "icon" | "aria-label"> & {
  onRemove: () => void;
};

export function TagRemove({
  onRemove,
  size = "2xs",
  ...props
}: TagRemoveProps) {
  return (
    <IconButton
      {...sharedProps}
      aria-label="Remove"
      icon={<RiCloseLine size={16} />}
      size={size}
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      {...props}
    />
  );
}
